export default "__VITE_ASSET__CSkqNipN__"